import { List, Record } from 'immutable';
import { THREAD_REMOVAL_TYPE } from './threadRemovalKeyPaths';
import { TICKET_ASSOCIATION } from './threadRemovalTypes';
const TicketAssociationRemoval = Record({
  [THREAD_REMOVAL_TYPE]: TICKET_ASSOCIATION,
  audit: null,
  members: List()
}, 'TicketAssociationRemoval');
export default TicketAssociationRemoval;